import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const pagesTitle: ThemeApp['appComponents']['pagesTitle'] = {
  color: themeUi.semantic.color.text.secondary50
};
